import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReactiveFormService } from '../../services/reactive-form.service';

@Component({
    selector: 'kt-input-textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.scss'],
})
export class TextboxComponent implements OnInit, OnChanges {
    @Input() fieldObj: any;
    @Input() options;
    @Input() values;
    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();
    emailPattern: any = '^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';

    // tslint:disable-next-line:no-inferrable-types
    isHideExpression = false;
    subscriptions: Subscription[] = [];
    prevValue: any = '';

    constructor(public formService: ReactiveFormService) { }

    ngOnInit() {
        this.setValidations();
        this.hideExpression();
        if (this.options && this.options.disabled) {
            this.form.get(this.options.key).disable();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue) {
            this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
        }
    }


    notifyChange(event) {
        this.valueChange.emit({ key: this.fieldObj.key, value: event.target.value });
    }

    hideExpression() {
        if (this.fieldObj && this.fieldObj.hideExpression && this.fieldObj.hideExpression.fieldName) {
            this.clearValidations();
            this.subscriptions.push(this.form.controls[this.fieldObj.hideExpression.fieldName].valueChanges.subscribe(val => {
                if (this.fieldObj.hideExpression.fieldValue === this.formService.matchValueExpression(val)) {
                    this.isHideExpression = false;
                    this.setValidations();
                } else {
                    this.clearValidations();
                }
            }));
        }
    }

    setValidations() {
        this.form.controls[this.fieldObj.key].validator =
            Validators.compose([this.fieldObj.required ? Validators.required : null,
            Validators.minLength(this.fieldObj.min_length), Validators.maxLength(this.fieldObj.max_length),
            this.fieldObj.type === 'email' ? Validators.pattern(this.emailPattern) : null]);
    }

    clearValidations() {
        this.isHideExpression = true;
        this.form.controls[this.fieldObj.key].clearValidators();
        this.form.controls[this.fieldObj.key].updateValueAndValidity();
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}

